'use client';

import dynamic from 'next/dynamic';

export const ProductComparisonTable = dynamic(() =>
  import('./ProductComparisonTable').then((m) => m.ProductComparisonTable)
);
